import { Box, Grid, Typography, Paper } from "@mui/material";

export default function Services() {
  return (
    <Box
      id="services"
      sx={{
        backgroundColor: "#F7FAFF",
        py: { xs: 6, md: 10 },
        fontFamily: "Roboto, sans-serif",
      }}
    >
      {/* PAGE WIDTH */}
      <Box sx={{ px: { xs: 2, sm: 4, md: "120px", lg: "250px" } }}>

        {/* HEADING */}
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography
            component="h1"
            sx={{
              fontSize: "32px",
              fontWeight: 700,
              color: "#2d2075",
              mb: 1,
            }}
          >
            Our Services
          </Typography>

          <Box
            sx={{
              width: 90,
              height: 3,
              backgroundColor: "#2d2075",
              mx: "auto",
            }}
          />
        </Box>

        {/* CONTENT CARD */}
        <Paper elevation={2} sx={{ p: { xs: 3, md: 5 } }}>

          {/* ===== FIRST PARAGRAPH (FULL WIDTH) ===== */}
          <Typography
            sx={{
              fontSize: "20px",
              color: "#333",
              lineHeight: 1.6,
              mb: 4,
            }}
          >
            Multitex Filters Pvt. Ltd. is a dynamic organization that has grown over
            the years from specialized Filtration and separation company and
            enhanced its core competency in delivering state-of-the-art solutions
            to its clients across the world.
          </Typography>

          {/* ===== SECOND PARAGRAPH + IMAGE ===== */}
          <Grid container spacing={6} alignItems="flex-start">

            {/* TEXT */}
            <Grid item xs={12} md={7}>
              <Typography
                sx={{
                  fontSize: "20px",
                  color: "#333",
                  lineHeight: 1.6,
                }}
              >
                At Multitex, we have identified the need to follow Project Management
                Tools to ensure the quality of the deliverables are top-notch and in
                line with International standards. Due to the complexity of managing
                a large number of manpower, materials, time etc. in a given time for
                the various projects, it makes sense to follow a standard procedure
                to maintain quality at all times and create necessary gated controls
                for critical stages.
              </Typography>
            </Grid>

            {/* IMAGE */}
            <Grid item xs={12} md={5}>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: { xs: "center", md: "flex-end" },
                }}
              >
                <img
                  src="/Service.png"
                  alt="Multitex Services"
                  style={{
                    width: "100%",
                    maxWidth: "420px",
                    height: "100%",
                    objectFit: "contain",
                    display: "block",
                  }}
                />
              </Box>
            </Grid>

          </Grid>
        </Paper>
      </Box>
    </Box>
  );
}
